type Segment = {
    Name: string;
    TravelAmountMin: number;
    TravelAmountMax: number;
    CreditScoreMin: number;
    CreditScoreMax: number;
    ROI: number;
    ProcessingFee: number;
    Gst: number;
    MinProcessingFee: number;
    UpfrontEmi: boolean;
    DownPayment?: number;
};

type PaymentPlan = {
    Segment: Segment[];
};

type Root010724 = {
    paymentPlan: PaymentPlan[];
};

type PlanDetails = {
    plan_id: string;
    loan_amount: number;
    processing_fee: number;
    gst: number;
    tenor: number;
    emi_amount: number;
    roi: number;
    interest_amount: number;
    package_cost: number;
};

// export function getSimplifiedTravelPlans(loanAmount: number, creditScore: number): PlanDetails[] {
//     const planDetails: PlanDetails[] = [];
//     const json = `{"paymentPlan":[{"Segment":[
//         {"Name":"WalkIn","TravelAmountMin":3000,"TravelAmountMax":49999,"CreditScoreMin":2000,"CreditScoreMax":2000,
//         "ROI":0.02,"ProcessingFee":0.02,"Gst":0.18,"MinProcessingFee":400,"UpfrontEmi":true},
//         {"Name":"WalkIn","TravelAmountMin":50000,"TravelAmountMax":1000000,"CreditScoreMin":2000,"CreditScoreMax":2000,
//         "ROI":0.015,"ProcessingFee":0.02,"Gst":0.18,"MinProcessingFee":400,"UpfrontEmi":true},
//         {"Name":"Silver","TravelAmountMin":3000,"TravelAmountMax":49999,"CreditScoreMin":0,"CreditScoreMax":650,
//         "ROI":0.03,"ProcessingFee":0.02,"DownPayment":0,"UpfrontEmi":true,"Gst":0.18,"MinProcessingFee":400},
//         {"Name":"Gold","TravelAmountMin":3000,"TravelAmountMax":49999,"CreditScoreMin":651,"CreditScoreMax":700,
//         "ROI":0.025,"ProcessingFee":0.02,"DownPayment":0,"UpfrontEmi":true,"Gst":0.18,"MinProcessingFee":400},
//         {"Name":"Platinum","TravelAmountMin":3000,"TravelAmountMax":49999,"CreditScoreMin":701,"CreditScoreMax":1000,
//         "ROI":0.02,"ProcessingFee":0.02,"DownPayment":0,"UpfrontEmi":true,"Gst":0.18,"MinProcessingFee":400},
//         {"Name":"Gold","TravelAmountMin":50000,"TravelAmountMax":1000000,"CreditScoreMin":0,"CreditScoreMax":700,
//         "ROI":0.0175,"ProcessingFee":0.02,"DownPayment":0,"UpfrontEmi":true,"Gst":0.18,"MinProcessingFee":400},
//         {"Name":"Platinum","TravelAmountMin":50000,"TravelAmountMax":1000000,"CreditScoreMin":701,"CreditScoreMax":1000,
//         "ROI":0.015,"ProcessingFee":0.02,"DownPayment":0,"UpfrontEmi":true,"Gst":0.18,"MinProcessingFee":400}
//     ]}]}`;

//     const paymentPlans: Root010724 = JSON.parse(json);
//     let planSegment: Segment | null = null;

//     for (const plan of paymentPlans.paymentPlan) {
//         for (const segment of plan.Segment) {
//             if (
//                 loanAmount >= segment.TravelAmountMin && loanAmount <= segment.TravelAmountMax &&
//                 creditScore >= segment.CreditScoreMin && creditScore <= segment.CreditScoreMax
//             ) {
//                 planSegment = segment;
//                 break;
//             }
//         }
//         if (planSegment !== null) break;
//     }

//     if (!planSegment) return planDetails;

//     const processingFee = Math.max(loanAmount * planSegment.ProcessingFee, planSegment.MinProcessingFee);
//     const gst = processingFee * planSegment.Gst;

//     let availableTenures: number[] = [];
//     if (loanAmount >= 3000 && loanAmount <= 50000) {
//         availableTenures = [3, 6, 9, 12];
//     } else if (loanAmount > 50000 && loanAmount <= 100000) {
//         availableTenures = [3, 6, 9, 12, 15, 18];
//     } else if (loanAmount > 100000 && loanAmount <= 1000000) {
//         availableTenures = [3, 6, 9, 12, 15, 18, 21, 24];
//     }

//     for (const tenure of availableTenures) {
//         const emi = (((planSegment.ROI * tenure * loanAmount) + loanAmount) / tenure);
//         const interestAmount = (emi * tenure) - loanAmount;

//         planDetails.push({
//             plan_id: "FNPL",
//             loan_amount: loanAmount,
//             processing_fee: processingFee,
//             gst: gst,
//             tenor: tenure,
//             emi_amount: emi,
//             roi: planSegment.ROI * 100,
//             interest_amount: interestAmount,
//             package_cost: loanAmount
//         });
//     }

//     return planDetails;
// }





export interface TenureRule {
    tenure: number;
    minCost: number;
    maxCost: number;
}

export interface ProcessingFeeRule {
    minLoanAmount: number;
    maxLoanAmount: number;
    fee: number;
}

interface NoCostTenureRule {
    Tenure: number;
    ProcessingFee: number;
}
export class PlanRuleMapper {

    static parseTenureRules(input: string): TenureRule[] {
        const result: TenureRule[] = [];
        const rules = input.split('|').filter(rule => rule.trim() !== '');

        for (let rule of rules) {
            const parts = rule.split('=');
            if (parts.length !== 2) continue;

            const tenurePart = parts[0].trim();
            const incomeRange = parts[1].trim();

            const incomeBounds = incomeRange.split('-');
            if (incomeBounds.length !== 2 ||
                isNaN(Number(incomeBounds[0])) ||
                isNaN(Number(incomeBounds[1]))) continue;

            const minIncome = parseFloat(incomeBounds[0]);
            const maxIncome = parseFloat(incomeBounds[1]);

            const tenures: number[] = [];

            for (let tenureToken of tenurePart.split(',')) {
                if (tenureToken.includes('-')) {
                    const rangeParts = tenureToken.split('-');
                    if (rangeParts.length === 2 && !isNaN(Number(rangeParts[0])) && !isNaN(Number(rangeParts[1]))) {
                        const start = parseInt(rangeParts[0], 10);
                        const end = parseInt(rangeParts[1], 10);
                        for (let i = start; i <= end; i++) {
                            tenures.push(i);
                        }
                    }
                } else if (!isNaN(Number(tenureToken))) {
                    tenures.push(parseInt(tenureToken, 10));
                }
            }

            // Add distinct tenures
            for (let tenure of [...new Set(tenures)]) {
                result.push({
                    tenure,
                    minCost: minIncome,
                    maxCost: maxIncome
                });
            }
        }

        return result;
    }

    static parseNoCostProcessingFeeRules(input: string): NoCostTenureRule[] {
        const result: NoCostTenureRule[] = [];
        const rules = input.split('|').filter(rule => rule.trim() !== '');

        for (const rule of rules) {
            const parts = rule.split('=');
            if (parts.length !== 2) continue;

            const tenurePart = parts[0].trim();
            const feePart = parts[1].trim();

            const processingFee = parseFloat(feePart);
            if (isNaN(processingFee)) continue;

            const tenures: number[] = [];

            for (const tenureToken of tenurePart.split(',')) {
                if (tenureToken.includes('-')) {
                    const rangeParts = tenureToken.split('-');
                    if (rangeParts.length === 2) {
                        const start = parseInt(rangeParts[0], 10);
                        const end = parseInt(rangeParts[1], 10);
                        if (!isNaN(start) && !isNaN(end)) {
                            for (let i = start; i <= end; i++) {
                                tenures.push(i);
                            }
                        }
                    }
                } else {
                    const singleTenure = parseInt(tenureToken, 10);
                    if (!isNaN(singleTenure)) {
                        tenures.push(singleTenure);
                    }
                }
            }

            for (const tenure of [...new Set(tenures)]) {
                result.push({
                    Tenure: tenure,
                    ProcessingFee: processingFee
                });
            }
        }

        return result;
    }

    static parseProcessingFeeRules(input: string): ProcessingFeeRule[] {
        const result: ProcessingFeeRule[] = [];
        const rules = input.split('|').filter(rule => rule.trim() !== '');

        for (let rule of rules) {
            const parts = rule.split('=');
            if (parts.length !== 2) continue;

            const incomeRange = parts[0].trim();
            const valuePart = parts[1].trim();

            const incomeBounds = incomeRange.split('-');
            if (incomeBounds.length !== 2 ||
                isNaN(Number(incomeBounds[0])) ||
                isNaN(Number(incomeBounds[1])) ||
                isNaN(Number(valuePart))) continue;

            const minLoanAmount = parseFloat(incomeBounds[0]);
            const maxLoanAmount = parseFloat(incomeBounds[1]);
            const fee = parseFloat(valuePart);

            result.push({
                minLoanAmount,
                maxLoanAmount,
                fee
            });
        }

        return result;
    }

    static getInterestAmountScoreByPercent(
        loanAmount: number,
        creditScore: number,
        rules: string
    ): number | null {

        const ruleEntries = rules.split('|');

        for (let rule of ruleEntries) {
            const parts = rule.split(':');
            if (parts.length !== 2) continue;

            const loanRange = parts[0];
            const creditRangeWithInterest = parts[1];

            const loanRangeParts = loanRange.split('-');
            const creditRangeParts = creditRangeWithInterest.split('=');

            if (loanRangeParts.length === 2 && creditRangeParts.length === 2) {
                const loanMin = parseFloat(loanRangeParts[0]);
                const loanMax = parseFloat(loanRangeParts[1]);

                const creditRange = creditRangeParts[0].split('-');
                const creditMin = parseInt(creditRange[0], 10);
                const creditMax = parseInt(creditRange[1], 10);

                const interestRate = parseFloat(creditRangeParts[1]);

                if (loanAmount >= loanMin && loanAmount <= loanMax &&
                    creditScore >= creditMin && creditScore <= creditMax) {
                    return interestRate;
                }
            }
        }

        return null;
    }

    static getProcessingFee(loanAmount: number, processingFeeRules: ProcessingFeeRule[], feeType: string): number {
        let processingFee = processingFeeRules
            .find(rule => loanAmount >= rule.minLoanAmount && loanAmount <= rule.maxLoanAmount)?.fee || 0;

        if (feeType === "ByPercent") {
            processingFee = (loanAmount * processingFee) / 100;
        }

        return processingFee;
    }


    static getSimplifiedTravelPlans(
        loanAmount: number,
        creditScore: number,
        availableTenure: string,
        processingFeeRule: string,
        processingFeeType: string,
        noCostTenureRule: string,
        noCostProcessingFeeRule: string,
        noCostProcessingFeeType: string,
        roiRule: string,
        roiType: string
    ): PlanDetails[] {

        const processingFees = PlanRuleMapper.parseProcessingFeeRules(processingFeeRule);

        const tenures = PlanRuleMapper.parseTenureRules(availableTenure);
        const noCostTenures = noCostTenureRule.split(',').map(t => parseInt(t.trim())).filter(t => !isNaN(t));
        const noCostProcessingFees = PlanRuleMapper.parseNoCostProcessingFeeRules(noCostProcessingFeeRule);

        let planDetails: PlanDetails[] = [];

        for (let tenure of tenures) {
            if (loanAmount < tenure.minCost || loanAmount > tenure.maxCost) continue;

            let processingFee = PlanRuleMapper.getProcessingFee(loanAmount, processingFees, processingFeeType);
            let gst = processingFee * 0.18;

            let ROIMonth = 0;
            if (roiType === 'AmountScoreByPercent') {
                ROIMonth = PlanRuleMapper.getInterestAmountScoreByPercent(loanAmount, creditScore, roiRule);
            }
            else {
                ROIMonth = parseFloat(roiRule) / 12;
            }

            // No cost EMI logic (Int = 0; custom processing fee)
            if (noCostTenures.includes(tenure.tenure)) {
                ROIMonth = 0;
                const noCostFee = noCostProcessingFees.find(nc => nc.Tenure === tenure.tenure);
                if (noCostFee) {
                    processingFee = noCostFee.ProcessingFee;
                    if (noCostProcessingFeeType === "ByPercent") {
                        processingFee = (loanAmount * processingFee) / 100;
                    }
                    gst = processingFee * 0.18;
                }
            };

            const plan: PlanDetails = {
                plan_id: "TNPL",
                loan_amount: loanAmount,
                processing_fee: processingFee,
                gst: Math.round(gst * 100) / 100,
                tenor: tenure.tenure,
                emi_amount: (((ROIMonth / 100) * tenure.tenure * loanAmount + loanAmount) / tenure.tenure),
                roi: Math.round(ROIMonth * 10000) / 10000,
                interest_amount: ROIMonth * tenure.tenure * loanAmount / 100,
                package_cost: loanAmount,
            };

            planDetails.push(plan);
        }

        return planDetails;
    }

    static mapToPartnerLenderConfig(data: any): PartnerLenderConfig {
        return {
            partnerLenderId: data.partnerLenderId,
            consolidatorId: data.consolidatorId,
            lenderId: data.lenderId,
            priority: data.priority,
            roi: data.roi,
            processingFee: data.processingFee,
            monthlyIncome: data.monthlyIncome,
            minCreditScore: data.minCreditScore,
            minAge: data.minAge,
            maxAge: data.maxAge,
            minAmount: data.minAmount,
            maxAmount: data.maxAmount,
            availableTenure: data.availableTenure,
            processingFeeType: data.processingFeeType,
            interestType: data.interestType,
            noCostTenure: data.noCostTenure,
            noCostProcessingFee: data.noCostProcessingFee,
            noCostProcessingFeeType: data.noCostProcessingFeeType,
            lender: this.mapToLender(data.lender)
        };
    }

    static mapToLender(lenderData: any): Lender {
        return {
            lenderId: lenderData.lenderId,
            lenderName: lenderData.lenderName
        };
    }
}

// partner-lender-config.model.ts
export interface Lender {
    lenderId: number;
    lenderName: string;
}

export interface PartnerLenderConfig {
    partnerLenderId: number;
    consolidatorId: string;
    lenderId: number;
    priority: number;
    roi: string;
    processingFee: string;
    monthlyIncome: number;
    minCreditScore: number;
    minAge: number;
    maxAge: number;
    minAmount: number;
    maxAmount: number;
    availableTenure: string;
    processingFeeType: string;
    interestType: string;
    noCostTenure: string;
    noCostProcessingFee: string;
    noCostProcessingFeeType: string;
    lender: Lender;
}
